import ajax from '../utils/request'
import config from '../config'

/**
 * ArticleService
 * @module service/Account
 */
export default {
  /**
   * 同步已登录的 token
   * @fires account/ticket/token:syncLogin
   * @param {String} id logined token
   */
  syncLogin (id) {
    /**
     * 执行同步登录 token 的接口
     * @event account/ticket/token:syncLogin
     * @property {Object}  data        request body
     * @property {String}  data.token  logined token
     */
    return ajax({
      host: config.accountHost,
      url: 'account/ticket/token',
      data: {
        token: id
      }
    })
  },
  /**
   * 获取用户的注册信息
   * @fires account/user/infoq:getRegisterInfo
   * @returns {Object}    res               返回数据
   * @returns {Timestamp} res.r_time        用户注册时间
   * @returns {Timestamp} res.current_time  当前服务器时间
   */
  getRegisterInfo () {
    /**
     * 执行获取用户的注册信息的接口
     * @event account/user/infoq:getRegisterInfo
     * @returns {Object}    res               返回数据
     * @returns {Timestamp} res.r_time        用户注册时间
     * @returns {Timestamp} res.current_time  当前服务器时间
     */
    return ajax({
      host: config.accountHost,
      url: 'account/user/infoq'
    })
  },
  /**
   * 新用户是否已领取礼物
   */
  getNewAccountGiftStatus () {
    return ajax({
      type: 'get',
      url: 'public/v1/activity/getRights'
    })
  },
  /**
   * 新用户领取礼物
   */
  getNewAccountGift () {
    return ajax({
      signin: true,
      type: 'get',
      url: 'public/v1/activity/addRights'
    })
  },
  /**
   * 获取登录状态
   * @fires serv/v1/user/auth:getSigninInfo
   * @returns {Object} res         返回数据
   * @returns {Number} res.uid     用户 ID
   * @returns {Url}    res.avatar  用户头像
   * @returns {String} res.nick    用户昵称
   */
  getSigninInfo () {
    /**
     * 执行获取登录状态的接口
     * @event serv/v1/user/auth:getSigninInfo
     * @returns {Object} res         返回数据
     * @returns {Number} res.uid     用户 ID
     * @returns {Url}    res.avatar  用户头像
     * @returns {String} res.nick    用户昵称
     */
    return ajax({
      type: 'get',
      host: config.accountHost,
      url: 'serv/v1/user/auth'
    })
  },
  /**
   * 登出
   * @fires account/ticket/delete:logout
   */
  logout () {
    /**
     * 执行获取用户的注册信息的接口
     * @event account/ticket/delete:logout
     */
    return ajax({
      host: config.accountHost,
      url: 'account/ticket/delete'
    })
  },
  /**
   * 获取作者信息
   * @param {String} uid  用户 ID
   * @fires public/v1/user/authorInfo:getAuthorInfo
   */
  getAuthorInfo (uid) {
    /**
     * 执行获取作者信息的接口
     * @event public/v1/user/authorInfo:getAuthorInfo
     * @property {Object}     data.id           request body
     * @property {Number}     data.id           用户 ID
     * @returns  {Object}     res                返回数据
     * @returns  {String}     res.uid            用户ID
     * @returns  {String}     res.nickname       昵称
     * @returns  {Url}        res.avatar         头像
     * @returns  {String}     res.intro          简介
     * @returns  {Boolean}    res.is_sub         是否已关注
     * @returns  {TimeStamp}  res.register_time  注册时间
     * @returns  {Number}     res.fan_count      粉丝数量
     */
    return ajax({
      url: 'public/v1/user/authorInfo',
      data: {
        id: uid | 0
      }
    })
    .then(res => res)
  },
  /**
   * 获取用户资料
   * @fires public/v1/user/getBaseInfo:getUserProfile
   * @param   {String}     uid  用户 ID
   * @returns {Object}     res            用户ID
   * @returns {String}     res.uid            用户ID
   * @returns {String}     res.nickname       昵称
   * @returns {Url}        res.avatar         头像
   * @returns {String}     res.intro          简介
   * @returns {String}     res.mood           心情签名
   * @returns {String}     res.industry       行业
   * @returns {String}     res.postion        职位
   * @returns {Boolean}    res.is_author      是否为作者
   * @returns {Timestamp}  res.register_time  注册时间
   * @returns {Number}     res.article_count  文章数量
   * @returns {Number}     res.fan_count      粉丝数量
   * @returns {Number}     res.sub_count      关注数量
   * @returns {Number}     res.topic_count    关注频道数量
   */
  getUserProfile (uid) {
    /**
     * 执行获取用户资料的接口
     * @event public/v1/user/getBaseInfo:getUserProfile
     * @property {Object}     data      request body
     * @property {String}     data.uid  用户 ID
     * @returns  {Object}     res            用户ID
     * @returns  {String}     res.uid            用户ID
     * @returns  {String}     res.nickname       昵称
     * @returns  {Url}        res.avatar         头像
     * @returns  {String}     res.intro          简介
     * @returns  {String}     res.mood           心情签名
     * @returns  {String}     res.industry       行业
     * @returns  {String}     res.postion        职位
     * @returns  {Boolean}    res.is_author      是否为作者
     * @returns  {Timestamp}  res.register_time  注册时间
     * @returns  {Number}     res.article_count  文章数量
     * @returns  {Number}     res.fan_count      粉丝数量
     * @returns  {Number}     res.sub_count      关注数量
     * @returns  {Number}     res.topic_count    关注频道数量
     */
    return ajax({
      url: 'public/v1/user/getBaseInfo',
      data: {
        id: uid | 0
      }
    })
    .then(res => res)
  },
  /**
   * 更新用户资料
   * @fires public/v1/user/updateInfo:updateUserProfile
   * @param {Object} data       参数
   * @param {String} data.type  修改类型 [mood:1签名, intro:2简介]
   * @param {String} data.value 修改值
   */
  updateUserProfile ({type, value}) {
    const postData = {}

    switch (type) {
      case 'mood':
        postData.type = 1
        postData.mood = value
        break
      case 'intro':
        postData.type = 2
        postData.intro = value
        break
      default:
        return Promise.reject({
          code: 1,
          message: '参数错误'
        })
    }

    /**
     * 执行更新用户资料的接口
     * @event public/v1/user/updateInfo:updateUserProfile
     * @property {Object}   data        request body
     * @property {Number}   data.type   参数类型
     * @property {String}   data.mood   用户签名
     * @property {String}   data.intro  用户简介
     */
    return ajax({
      signin: true,
      url: 'public/v1/user/updateInfo',
      data: postData
    })
  },
  /**
   * 关注/取消关注用户
   * @fires public/v1/subauthor/sub:followUser
   * @param {String}  uid     用户 ID
   * @param {Boolean} follow  关注/取消关注
   */
  followUser (uid, follow) {
    const url = follow ? 'public/v1/subauthor/sub' : 'public/v1/subauthor/unsub'

    /**
     * 执行关注/取消关注用户的接口
     * @event public/v1/subauthor/sub:followUser
     * @property {Url}      url       [关注:public/v1/subauthor/sub,取消:public/v1/subauthor/unsub]
     * @property {Object}   data      request body
     * @property {Number}   data.id   用户 ID
     */
    return ajax({
      signin: true,
      url,
      data: {
        id: uid | 0
      }
    })
  },
  /**
   * 注册 infoQ账号 - 发送注册的手机验证码
   * @param {Object} data           接口参数
   * @param {Number} data.country   国家区号
   * @param {Mobile} data.cellphone 手机号
   * @param {String} data.captcha   动态验证码
   */
  sendRegisterCode (data) {
    !data.captcha && delete data.captcha

    // return this.request(`${baseUrl}/account/register/code`, data)
    return ajax({
      host: config.account,
      url: 'account/register/code',
      data
    })
  },
  /**
   * 验证验证码
   * @param {String}  type  [sms: 免密登录, email: infoQ 邮箱, bindMobile: infoq 绑定手机号, register: 注册, password: 密码]
   * @param {String}  value  验证码
   */
  checkCaptcha (type, value) {
    let url = ''

    switch (type) {
      case 'wechat' :
        url = 'account/check/wechat'
        break
      case 'weibo' :
        url = 'account/check/weibo'
        break
      case 'qq' :
        url = 'account/check/qq'
        break
      case 'sms':
        url = 'account/check/smslogin'
        break
      case 'password':
        url = 'account/check/ticket'
        break
      case 'forgot':
        url = 'account/check/forgot'
        break
      case 'register':
        url = 'account/check/register'
        break
      case 'email':
        url = 'account/check/claimemail'
        break
      case 'bindMobile':
        url = 'account/check/claimcellphone'
        break
      default:
        break
    }
    return ajax({
      host: config.account,
      url: url,
      data: {captcha: value}
    })
  },
  /**
   * 免密快速注册
   * @param {String} country 区号
   * @param {Mobile} cellphone 手机号
   * @param {String} nickname 昵称
   * @param {Number} code 验证码
   * @param {String} ucode gk_code
   * @param {Number} appid [1:Geekbang, 5:InfoQ]
   * platform 网页端注册 都是 3
   */
  quicksignup (country, cellphone, nickname, code, ucode = '', appid = 1) {
    const postData = {
      country,
      cellphone,
      nickname,
      code,
      ucode,
      platform: 3,
      appid
    }

    if (appid !== 5) {
      postData.random_nickname = 1
    }

    // return this.request(`${baseUrl}/account/register/quick`, postData)
    return ajax({
      host: config.account,
      url: 'account/register/quick',
      data: postData
    })
  }
}
